/** URL parameters: every scene and knob is reachable without clicking (06 §8). */

export const query = new URLSearchParams(location.search);

export function pick<T extends string>(key: string, allowed: readonly T[], fallback: T): T {
  const v = query.get(key);
  return allowed.includes(v as T) ? (v as T) : fallback;
}

export function num(key: string, fallback: number): number {
  const v = Number.parseFloat(query.get(key) ?? '');
  return Number.isFinite(v) ? v : fallback;
}
